module.exports = __webpack_public_path__ + "img/Katarina_home_01.af4c7bb9.jpg";